import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-94d14a02"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("确定");

import { ref } from 'vue';
export default {
  setup: function setup(__props) {
    var formRef = ref(null);
    var form = ref({
      oldPassword: '',
      newPassword: '',
      newPasswordAgain: ''
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createBlock(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        "label-width": "120px",
        class: "container"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "原密码"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: form.value.oldPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.value.oldPassword = $event;
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: form.value.newPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return form.value.newPassword = $event;
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "再次输入新密码"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: form.value.newPasswordAgain,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return form.value.newPasswordAgain = $event;
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            class: "saveButton"
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model"]);
    };
  }
};